import {
  FaChartBar,
  FaDatabase,
  FaBell,
  FaPuzzlePiece,
} from "@onemind-services-llc/react-icons-ng/fa";
import { SimpleList } from "@/components/list";
import HeroBg from "public/marketplace-apps/hero/Hero-section-grafana.png";

export const GRAFANA_CONSTANTS = {
  HERO: {
    title: "OneMind Services — Grafana Monitoring (One-Click Application) ",
    desc: "Elevate your monitoring capabilities with OneMind’s fully managed Grafana. We handle the infrastructure, so you can focus on visualizing your data effectively.",
    button: {
      label: "Try Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "Grafana is the go-to open-source platform for monitoring and observability. It empowers you to query, visualize, alert on, and understand your metrics—regardless of where the data resides. With flexible dashboards, real-time alerting, and a vast plugin ecosystem, Grafana supports diverse use cases such as IT operations, infrastructure monitoring, application performance, and business analytics ",
  },
  WHY_ONEMIND: {
    title: "Deploy Effortlessly with OneMind Ease ",
    desc: [
      {
        highlight: "One-Click Installation",
        text: " One-Click Installation : Launch a fully configured and secure Grafana instance in minutes—no need to install or manage dependencies.",
      },
      {
        highlight: "Global Reach",
        text: " Global Reach : Deploy in any of our multiple data-center regions to keep latency low and performance high  ",
      },
      {
        highlight: "Pre‑Configured Setup",
        text: " Pre‑Configured Setup : Includes Grafana Engine, default admin credentials, and optimized system settings. ",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Access & Administration ",
    desc: [
      {
        text: "Once deployed, you’ll receive in your console:",
      },
      {
        text: " Username :",
        highlight: "admin",
      },
      {
        text: " Password :",
        highlight: "<generated-password>",
      },
    ],
    installation: {
      heading: "Installation Location -",
      text: "The configuration file is located in the directory",
      location: "/etc/grafana/grafana.ini  ",
    },
    ports: {
      heading: "Ports Used ",
      text: "Application, besides standard Ubuntu Ports (53/22), uses: ",
      list: ["3000"],
    },
    note: "Note : Find the configuration file at /etc/grafana/grafana.ini for customized tweaks or backup ",
  },
  FEATURES: {
    items: [
      {
        icon: FaChartBar,
        title: "Interactive Dashboards & Visualizations",
        children: (
          <SimpleList
            points={[
              "Rich, interactive charts, graphs, tables, and heatmaps.",
              "Drag-and-drop panel composition with dynamic variables.",
            ]}
          />
        ),
      },
      {
        icon: FaDatabase,
        title: "Multi-Data‑Source Support",
        children: (
          <SimpleList
            points={[
              "Seamlessly integrate Prometheus, InfluxDB, Elasticsearch, Graphite, etc.",
              "Leverage official and community plugins for extended integration.",
            ]}
          />
        ),
      },
      {
        icon: FaBell,
        title: "Built-In Alerting & Notifications",
        children: (
          <SimpleList
            points={[
              "Define alert rules based on metrics, logs, or thresholds.",
              "Route alerts through email, Slack, PagerDuty, and more.",
            ]}
          />
        ),
      },
      {
        icon: FaPuzzlePiece,
        title: "Plugin Ecosystem",
        children: (
          <SimpleList
            points={[
              "Add support for new data sources, visual panels (maps, clocks).",
              "Integrate apps like Zabbix, OnCall, and more.",
            ]}
          />
        ),
      },
    ],
  },
  BENEFITS: {
    title: "Resilience & Scaling ",
    options: [
      {
        label: "Backups & Snapshots",
        text: "Use OneMind’s snapshot feature or integrate standard backup procedures for Grafana data and plugins. ",
      },
      {
        label: "Security Out of the Box",
        text: "Hardened with firewall rules, TLS ready, and RBAC configured. ",
      },
      {
        label: "Scalable Architecture",
        text: "Scale compute, memory, storage; optionally bundle with Prometheus and Loki for full-stack observability via our Cloud Alliance. ",
      },
    ],
  },
  SUPPORT: {
    docsText: "Grafana Documentation",
    docsLink: "https://grafana.com/docs/",
  },
};
